module.exports = __webpack_public_path__ + "img/stock0.9dd7df93.png";